<template>
    <i v-bind:class="icon(activity)"/>
</template>

<script>
export default {
  name: 'activity-icon',
  props: ['activity'],
  methods: {
    icon (activity) {
      switch (activity.action) {
        case 'destroy':
          return 'fa fa-trash'
        case 'update':
          return 'fa fa-pencil'
        case 'purchase':
          return 'fa fa-plus'
        case 'create':
          return 'fa fa-plus'
        default:
          return 'fa fa-question'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ActivityIcon.vue